module.exports = __webpack_public_path__ + "static/media/empty.b69cbc26.svg";